window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

//forgot password form
var forgotPassword = (function() {
	var forgotBtn = $("#forgot-password"),
		loginForm = $("#login-form"),
		forgotForm = $("#forgot-password-form"),
		recoverPasswordErrors = $("#forgot-password-form account-input-div.recover-errors");
		sentEmail = $("#successful-post");

	if(forgotBtn.length) forgotBtn.click(function() {
		loginForm.hide();
		forgotForm.show();
		$("#login-header").text('RECOVER PASSWORD');
	});

	if(sentEmail.length) $("#form-reset-success").html("<p><em>Reset Password Email Sent!</em></p>");
	if(recoverPasswordErrors.length) $("#form-reset-success").html(recoverPasswordErrors.html());
})();

//open/closing add/edit addresses
var accountPage = (function() {
	var addBtn = $("#add-address"),
		cancelBtn = $("#cancel-address-form"),
		addressForm = $("#address-form"),
		addressErrors = $("#address-form-errors"),
		editAddressBtn = $(".edit-address-link"),
		cancelEditBtn = $(".cancel-edit-address");

	if(editAddressBtn.length) editAddressBtn.click(editAddress);
	if(addressErrors.length) addressForm.slideDown();

	if(cancelBtn.length) cancelBtn.click(function() {
		addressForm.slideUp();
	});

	if(addBtn.length) addBtn.click(function() {
		addressForm.slideDown();
	});

	if(cancelEditBtn.length) cancelEditBtn.click(function() {
		$(this).parents('.edit-address').slideUp();
	});

	function editAddress() {
		$(this).parents('.customer-address').find('.edit-address').slideDown();
	}
})();	

/*================ SLEEPLESS ================*/
var navbarScroll = (function() {
	var $window = $(window),
		navShadow = $("#nav-scroll-shadow"),
		mobileShadow = $("#mobile-nav-shadow"),
		mobilePhone = $(".mobile-phone-info"),
		flyout = $("#flyout"),
		navbar = $("#navbar");

	if(!$('body').hasClass('interior')) {
		handleScroll();
		$window.scroll(function() {
			window.requestAnimationFrame(handleScroll);
		});
	} else {
		handleAltNavScroll();
		$window.scroll(function() {
			window.requestAnimationFrame(handleAltNavScroll);
		});
	}

	$window.resize(function() {
		if($window.width() <= 700 && $window.scrollTop() < 50) {
			mobilePhone.css('margin-top', '0');
			navShadow.css('height', '140px');
		} else {
			mobilePhone.css('margin-top', '-70px');
			navShadow.css('height', '70px');
		}

		if($window.width() <= 600) {
			$(".link-grouping .list, .link-grouping .email-input").removeAttr('style');
		}
	});

	function handleScroll() {
		if(navbar.hasClass('search-open')) return;
		var winScroll = $window.scrollTop();
		if(winScroll < 80 && navbar.hasClass('scrolled') && !flyout.hasClass('active')) {
			navbar.removeClass("scrolled");
			navShadow.removeClass("active");
			if($window.width() <= 700) {
				mobilePhone.stop().css('margin-top', '0');
			} else {
				mobilePhone.css('margin-top', '-70px');
			}
		} else if(winScroll >= 80 && !navbar.hasClass('scrolled')) {
			navbar.addClass("scrolled");
			navShadow.addClass("active");
			navShadow.css('height', '70px');
			if($window.width() <= 700) {
				mobilePhone.stop().animate({
					marginTop: '-70px'
				}, 200);
			}
		}
	}

	function handleAltNavScroll() {
		if(navbar.hasClass('search-open')) return;
		var winScroll = $window.scrollTop();
		if(winScroll < 80 && mobilePhone.hasClass("active")) {
			mobilePhone.removeClass("active");
			if($window.width() <= 700) {
				navShadow.css('height', '140px');
				mobilePhone.stop().css('margin-top', '0');
			} else {
				mobilePhone.css('margin-top', '-70px');
			}
		} else if(winScroll >= 80 && !mobilePhone.hasClass("active")) {
			mobilePhone.addClass("active");
			navShadow.addClass("active");
			if($window.width() <= 700) {
				//mobilePhone.css('margin-top', '0');
				navShadow.stop().animate({
					'height': '70px'
				}, 200);
				mobilePhone.stop().animate({
					marginTop: '-70px'
				}, 200);
			}
		}
	}
})();

var navSearch = (function() {
	var searchContainer = $("#navbar .search-icon"),
		searchButton = $("#navbar .search-icon .activate-nav-search"),
		searchInput = searchContainer.find('input'),
		mobileSearchInput = $("#navbar .mobile-header-search-input"),
		mobileSearchContainer = $("#navbar .mobile-header-search"),
		mobilePhone = $(".mobile-phone-info"),
		navShadow = $("#nav-scroll-shadow"),
		contactInfo = $("#navbar .nav-contact-info.main"),
		overlay = $("#search-overlay"),
		logo = $("#nav-logo"),
		body = $("body");

	function isMobileSearch() {
		return $(window).width() <= 700;
	}

	function activeSearchInput() {
		return mobileSearchInput;
	}

	function openSearch() {
		body.addClass('no-scroll-fixed');
		$("#navbar").addClass('search-open');
		searchContainer.addClass('active');
		searchContainer.find('form').addClass('active');
		mobileSearchContainer.addClass('active');
		$("#ui-id-1").addClass('navbar');
		$("#ui-id-2").addClass('navbar');
		$(".main-nav-link").addClass('hide-link');
		$(".main-nav-link.hide-link.nav").fadeOut(225);
		activeSearchInput().focus();
		overlay.fadeIn(225);
		if(isMobileSearch()) {
			logo.fadeOut(225);
			mobilePhone.stop(true, true).hide();
			navShadow.css('height', '70px');
		}
	}

		searchButton.click(function() {
			if($("#flyout").hasClass('active')) {
				flyout.activate();
			}
			if(body.hasClass('template-index') && !isMobileSearch()) {
				$('html, body').animate({
					scrollTop: 0
				}, 350);
				$(".input-holder input").focus();
			} else {
				openSearch();
			}
		});

		function closeSearch() {
			body.removeClass('no-scroll-fixed');
			$("#navbar").removeClass('search-open');
			searchContainer.removeClass('active');
			searchContainer.find('form').removeClass('active');
			mobileSearchContainer.removeClass('active');
			$(".main-nav-link").removeClass('hide-link');
			$(".main-nav-link.hide-link.nav").fadeIn(225);
			$("#ui-id-1").removeClass('navbar').hide();
			$("#ui-id-2").removeClass('navbar').hide();
			contactInfo.removeClass('active');
			overlay.fadeOut(225);
			logo.fadeIn(225);
			searchInput.val("");
			mobileSearchInput.val("");
			searchContainer.removeAttr('style');
			if(isMobileSearch()) {
				mobilePhone.show();
				if($(window).scrollTop() >= 80) {
					mobilePhone.css('margin-top', '-70px');
					navShadow.css('height', '70px');
				} else {
					mobilePhone.css('margin-top', '0');
					navShadow.css('height', '140px');
				}
			}
		}

		searchInput.blur(function() {
			if($("#navbar").hasClass('search-open')) return;
			closeSearch();
		});

		mobileSearchInput.blur(function() {
			closeSearch();
		});

		mobileSearchInput.on('input keyup', function() {
			searchInput.val($(this).val());
			searchInput.trigger('input').trigger('keyup');
		});
})();

var flyout = (function() {
	var flyoutButtons = $(".flyout-button"),
		navShadow = $("#nav-scroll-shadow"),
		body = $("body"),
		overlay = $("#flyout-overlay"),
		navbar = $("#navbar"),
		flyout = $("#flyout");

	flyoutButtons.click(activateFlyout);
	overlay.click(activateFlyout);

	function activateFlyout() {
		if(flyout.hasClass('active')) {
			flyoutButtons.removeClass('active');
			flyout.removeClass('active');
			if($(window).scrollTop() < 50 && !$('body').hasClass('interior')) {
				navbar.removeClass("scrolled");
				navShadow.removeClass("active");
			}
			body.removeClass('no-scroll-fixed');
			overlay.fadeOut(200);
		} else {
			if(!$('body').hasClass('interior')) {
				navbar.addClass("scrolled");
				navShadow.addClass("active");
			}
			$(this).addClass('active');
			flyout.addClass('active');
			body.addClass('no-scroll-fixed');
			overlay.fadeIn(200);
		}
	}

	return {
		activate: activateFlyout
	}
})();

var footerAccordion = (function() {
	var titles = $("#footer .link-grouping h3");

	titles.click(function() {
		if($(window).width() <= 600) {
			if($(this).next().css('display') === 'block') {
				titles.next().slideUp(300);
				titles.removeClass('active');
			} else {
				titles.next().slideUp(300);
				titles.removeClass('active');
				$(this).next().stop().slideDown(300);
				$(this).addClass('active');
			}
		}
	})
})();
var homeEquipmentCarousel = $("#home-equipment-carousel .owl-carousel"),
	homeManufacturers = $("#home-manufacturers .owl-carousel");

if(homeEquipmentCarousel.length) {
	var leftArrowSrc = $('#left-carousel-arrow-src').text(),
		rightArrowSrc = $('#right-carousel-arrow-src').text();

	homeEquipmentCarousel.owlCarousel({
		items: 4,
		loop: true,
		autoplay:true,
		nav:true,
		navText: [
			'<img src="' + leftArrowSrc + '" class="carousel-arrow left" alt="carousel arrow left"/>',
			'<img src="' + rightArrowSrc + '" class="carousel-arrow right" alt="carousel arrow right"/>'
		],
		responsive: {
			0: {
				items: 1
			},
			600: {
				items: 2
			},
			850: {
				items: 3
			},
			1100: {
				items: 4
			}
		}
	});
}

if(homeManufacturers.length) {
	homeManufacturers.owlCarousel({
		items: 6,
		loop: true,
		autoplay:true,
		responsive: {
			0: {
				items: 2
			},
			600: {
				items: 3
			},
			991: {
				items: 4
			},
			1150: {
				items: 6
			}
		}
	});
}
var parallaxScroll = (function() {
	
	var homeMiddle = $("#home-middle"),
		homeBottom = $("#home-bottom"),
		pageHeader = $(".page-header"),
		navHeight = 70,
		lastScrollTop = 0,
		$window = $(window);

	var pics = [];

	if(homeMiddle.length) {
		pics.push({
			picture: $("#home-middle .parallax-pic.left img"),
			type: "normal",
			container: homeMiddle,
			containerOffset: homeMiddle.offset(),
			multiplier: 45
		});
		pics.push({
			picture: $("#home-middle .parallax-pic.right img"),
			type: "normal",
			container: homeMiddle,
			containerOffset: homeMiddle.offset(),
			multiplier: 22
		});
	}
	if(homeBottom.length) {
		pics.push({
			picture: $("#home-bottom .parallax-pic.left img"),
			type: "normal",
			container: homeBottom,
			containerOffset: homeBottom.offset(),
			multiplier: 40
		});
		pics.push({
			picture: $("#home-bottom .parallax-pic.right img"),
			type: "normal",
			container: homeBottom,
			containerOffset: homeBottom.offset(),
			multiplier: 40
		});
	}

	if(pics.length && $(window).width() > 1024) {
		$window.scroll(_.debounce(iteratePics, 10, {leading: true}));
	} else if(pics.length && $(window).width() <= 1024) {
		for(var i=0;i<pics.length;i++) {
			pics[i].picture.addClass('normalize');
		}
	}
	function iteratePics() {
		var scrollTop = $window.scrollTop(),
			scrollBottom = scrollTop + $window.height();
		for(var i=0;i<pics.length;i++) {
			parallaxCheck(pics[i], scrollTop, scrollBottom);
		}
		lastScrollTop = scrollTop;
	} 

	function parallaxCheck(el, scrollTop, scrollBottom) {
		if(scrollBottom > el.containerOffset.top && scrollTop < (el.containerOffset.top + el.container.height() + navHeight)) {
			var diff = scrollBottom - el.containerOffset.top,
				percent = el.multiplier - ((diff/($window.height() + (el.container.height() + navHeight))) * el.multiplier);

			if(el.type === "flipped") {
				percent = ((diff/($window.height() + (el.container.height() + navHeight))) * el.multiplier);
			}

			var newTranslate = 'translate3d(0, -' + percent + '%, 0)';
			el.picture.css({
				'transform': newTranslate,
				'-webkit-transform': newTranslate,
				'-mox-transform': newTranslate,
				'-ms-transform': newTranslate
			});
			/*
			var duration = 800,
				diff = Math.abs(lastScrollTop - scrollTop);
			if(diff > 300) {
				duration  = 700;
			} else if(diff < 50) {
				duration = 925;
			}
			console.log(el.picture.css('text-indent'))
			el.picture.stop().animate({
				'text-indent': percent
			}, {
				step: function(now, fx) {
					var newTranslate = 'translate3d(0, -' + now + '%, 0)';
					el.picture.css({
						'transform': newTranslate,
						'-webkit-transform': newTranslate,
						'-mox-transform': newTranslate,
						'-ms-transform': newTranslate
					});
				},
				duration: duration,
				easing: 'swing',
				queue: false
			}, 'swing');
			*/
		}
	}
	if(pics.length) {
		iteratePics();
	}
})();
(function(Modernizr){
  var tests = [
    { name: 'polygon', value: 'polygon(50% 0%, 0% 100%, 100% 100%)' }
    ];

    var t = 0,
    name, value, prop;

    for (; t < tests.length; t++) {
      name = tests[t].name;
      value = tests[t].value;
      Modernizr.addTest('cssclippath' + name, function(){
      // Try using window.CSS.supports
      if ( 'CSS' in window && 'supports' in window.CSS ) {
        for (var i = 0; i < Modernizr._prefixes.length; i++) {
          prop = Modernizr._prefixes[i] + 'clip-path';

          if ( window.CSS.supports(prop,value) ) { return true; }
        }
        return false;
      }
      // Otherwise, use Modernizr.testStyles and examine the property manually
      return Modernizr.testStyles('#modernizr { '+Modernizr._prefixes.join('clip-path:'+value+'; ')+' }',function(elem, rule) {
        var style = getComputedStyle(elem),
        clip = style.clipPath;

        if ( !clip || clip == "none" ) {
          clip = false;

          for (var i = 0; i < Modernizr._domPrefixes.length; i++) {
            test = Modernizr._domPrefixes[i] + 'ClipPath';
            if ( style[test] && style[test] !== "none" ) {
              clip = true;
              break;
            }
          }
        }

        return Modernizr.testProp('clipPath') && clip;
      });
    });
  }
})(Modernizr);

if(!Modernizr.cssclippathpolygon) {
  $(".clip-path").addClass('fallback');
  $(".theme-button").addClass('fallback');
}
var productVariants = (function() {
	var productSelect = $("#product-variants-select"),
		variants = productSelect.children('option'),
		priceField = document.getElementById('price-field'),
		availableVariants = [],
		optionSelects = $(".option-wrapper-select"),
		submitBtn = document.getElementById('product-submit');

	if(optionSelects.length) optionSelects.change(updateVariants);

	if(productSelect.length) {
		//loop through hidden variants and turn them into usable objects
		for(var i=0;i<variants.length;i++) {
			var options = variants[i].getAttribute('data-options').split(",");
			for (var k = 0; k < options.length; k++) {
				options[k] = decodeURIComponent(options[k]);
			}
			var newVariant = {"options": options, "id": variants[i].getAttribute('value'), "price": variants[i].getAttribute('data-price')}
			availableVariants.push(newVariant);
		}
		if(optionSelects.length) updateVariants();
		if(variants.length == 0) {
			setSubmitButton(true);
		}
	}

	function updateVariants() {
		var currentOptions = getCurrentOptions(),
			matchedVariant = null,
			inStock = false;
		//loop through all variants
		for(var i=0;i<availableVariants.length;i++) {
			var variantOptions = availableVariants[i].options,
				count = 0;
			//loop through options for current variant
			for(var j=0;j<variantOptions.length;j++) {
				//loop through selected options and check if they match with variantOptions
				var selectedOptions = currentOptions;
				for(var k=0;k<currentOptions.length;k++) {
					if(variantOptions[j] === selectedOptions[k]) {
						count++;
					}
				}
			}
			//if count equals options length that means the variant is available
			if(count === variantOptions.length) {
				inStock = true;
				matchedVariant = availableVariants[i];
				priceField.innerHTML = matchedVariant.price;
				break;
			}
		}
		if(inStock) {
			//change selected variant in official product select
			for(var i=0;i<variants.length;i++) {
				if(variants[i].getAttribute('value') === matchedVariant.id) {
					variants[i].setAttribute('selected', 'selected');
				} else variants[i].removeAttribute('selected');
			}
			setSubmitButton(false);
		} else {
			setSubmitButton(true);
		}
	}

	function setSubmitButton(disable) {
		if(!submitBtn) return;
		if(disable) {
			submitBtn.setAttribute('disabled', 'disabled');
			$(submitBtn).hide();
			$(submitBtn).children('span').text('SOLD OUT');
			$(".contact-button").show();
		} else {
			submitBtn.removeAttribute('disabled');
			$(submitBtn).children('span').text('ADD TO CART');
		}
	}

	function getCurrentOptions() {
		//get array of currently selected options
		var options = [];
		for(var i=0;i<optionSelects.length;i++) {
			options.push(decodeURIComponent(optionSelects[i].value));
		}
		return options;
	}
})();
var productImages = (function() {
	var smallImages = $(".product-small-pic-container .small-image"),
		bigImages = $("#product-pic-container .big-image");

	smallImages.click(changeImage);

	function changeImage() {
		var smallId = $(this).attr('data-id'),
			activePic = null,
			nextPic = null;

		//find active image and next image
		for(var i=0;i<bigImages.length;i++) {
			if(bigImages[i].getAttribute('data-id') === smallId) {
				nextPic = bigImages[i];
			}
			if(bigImages[i].getAttribute('data-active') === 'true') {
				activePic = bigImages[i];
			}
		}

		activePic = $(activePic);
		nextPic = $(nextPic);

		activePic.hide().attr('data-active', 'false').children('img').removeClass('active');
		nextPic.show().attr('data-active', 'true').children('img').addClass('active');
	}

})();

var productAccordion = (function() {
	var accTitles = $("#product-page .accordion-title");

	accTitles.click(function() {
		var parent = $(this).parent();
		if(parent.hasClass('active')) {
			accTitles.parent().removeClass('active');
			accTitles.next().slideUp(200);
		} else {
			accTitles.parent().removeClass('active');
			accTitles.next().slideUp(200);
			parent.addClass('active');
			$(this).next().stop().slideDown(200);
		}
	});
})();

var productShareLinks = (function() {
	var links = $(".product-social-icons a");
	for(var i=0;i<links.length;i++) {
		var thisLink = $(links[i]),
			shareUrl = "";
		if(thisLink.hasClass('fa-twitter-square')) {
			shareUrl = 'https://twitter.com/share?url=' + window.location.href;
		} else if(thisLink.hasClass('fa-facebook-square')) {
			shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href;
		}
		thisLink.attr('href', shareUrl);
	}
})();

var customNumberInput = (function() {
	var numberInputs = $(".custom-number-input .number-change");

	numberInputs.click(function() {
		var input = $(this).parent().children('input');
		if($(this).hasClass('increase')) {
			input.val(parseInt(input.val()) + 1);
		} else {
			var nextNum = parseInt(input.val()) - 1;
			if(nextNum < 0) {
				input.val(0);
			} else {
				input.val(nextNum);
			}
		}
	});
})();

var storeDetailsForOrder = (function() {
	if($('body').hasClass('template-product')) {
		var picSrc = $("#product-page .big-image img").attr('src'),
			picTitle = $("#product-title").text();
			picManu = $("#product-manufacturer").text();

		localStorage.setItem('productPic', picSrc);
		localStorage.setItem('productTitle', picTitle);
		localStorage.setItem('productManufacturer', picManu);
	}
	if($('body').attr('id') === "place-order" && localStorage.getItem('productTitle')) {
		var message = $("#form-message"),
			splitMessage = message.text().split("(product name)"),
			productTitle = localStorage.getItem('productTitle'),
			productManufacturer = localStorage.getItem('productManufacturer')

		message.text(splitMessage[0] + productTitle + splitMessage[1]);

		$("#product-title-input").val(productTitle);

		var newImg = document.createElement('img');
		newImg.src = localStorage.getItem('productPic');
		newImg.alt = productTitle + " Place Order";
		$("#storage-product-pic").html(newImg);
		$("#productTitle").html(productTitle);
		$("#productManu").html(productManufacturer);
	}
})();
var searchBar = (function() {
	var searchInputs = $(".search-input");

	if($(window).width() < 550) {
		searchInputs.parent().find('.placeholder').html("<strong>Search</strong>");
	}

	$(window).resize(_.debounce(function() {
		var placeholder = searchInputs.parent().find('.placeholder');
		if($(window).width() < 550) {
			placeholder.html("<strong>Search</strong>");
		}
	}, 200));

	searchInputs.keydown(function() {
		var placeholders = searchInputs.parent().find('.placeholder');
		placeholders.hide();
	});

	searchInputs.keyup(function() {
		var placeholders = searchInputs.parent().find('.placeholder');
		if($(this).val().length > 0) {
			placeholders.hide();
			searchInputs.val($(this).val());
		} else {
			placeholders.show();
		}
	})
})();
var filterSidebar = (function() {
	var accTitles = $("#collection-filter-sidebar h4");

	accTitles.click(activateAccordion);

	function activateAccordion() {
		var neverClose = $(this).children('a').length;
		if(!neverClose) {
			if($(this).parent().hasClass('active')) {
				closeCorrectItems();
			} else {
				closeCorrectItems();
				$(this).parent().addClass('active');
				$(this).next().stop().slideDown(300);
			}
		}

		function closeCorrectItems() {
			for(var i=0;i<accTitles.length;i++) {
				var thisTitle = $(accTitles[i]);
				//if title has a link in it, it no longer functions as accordion item
				if(!thisTitle.children('a').length) {
					thisTitle.parent().removeClass('active');
					thisTitle.next().slideUp(300);
				}
			}
		}
	}

	function pageLoadOpen() {

		if($(window).width() > 991) {
			var item = $("#collection-filter-sidebar .accordion-item.equipment");
			if(/type=/.test(window.location.href)) {
				var split = window.location.href.split("type="),
					viewType = split[1].split('&')[0];
				if(viewType === "brand") {
					item = $("#collection-filter-sidebar .accordion-item.manufacturers");
				}
			}
			item.addClass("active");
			item.find(".accordion-list").slideDown(300);
		}
	}

	pageLoadOpen();
})();

var collectionSelects = (function() {
	var selects = $(".collection-select select"),
		currentUrl = window.location.href;

	//construct new url with changes
	selects.change(function() {
		//if sort select
		if($(this).parent().hasClass('sort-select')) {
			constructUrl("sort_by", $(this).val());
		} else if($(this).parent().hasClass("items-select")) {
			constructUrl("view", $(this).val());
		};

		function constructUrl(newParam, val) {
			var baseUrl = currentUrl.split("?")[0];
			//grab params if any
			var params = window.location.href.split("?");
			if(params.length > 1) {
				//split up each param
				var splitParams = params[1].split("&"),
					paramRegex = new RegExp(newParam, 'i');
				//check for sort in params, overwrite old sort with new
				for(var i=0;i<splitParams.length;i++) {
					if(paramRegex.test(splitParams[i])) {
						splitParams[i] = newParam + "=" + val;
					}
				}
				//if newParam not in params, add
				var newParams = splitParams.join('&');
				if(!paramRegex.test(newParams)) {
					newParams += "&" + newParam + "=" + val;
				}
				baseUrl += "?" + newParams;
			} else {
				baseUrl += "?" + newParam + "=" + val;
			}
			window.location.href = baseUrl;
		}
	});

	if(/sort_by=/.test(currentUrl)) {
		var split = currentUrl.split("sort_by="),
			sort = split[1].split('&')[0];
		
		$(".sort-select select").children().each(function() {
			if(this.getAttribute('value') === sort) {
				this.setAttribute('selected', 'selected');
				$(".sort-select label").text(this.innerHTML);
			}
		});
	}

	if(/view=/.test(currentUrl)) {
		var split = currentUrl.split("view="),
			items = split[1].split('&')[0];
		
		$(".items-select select").children().each(function() {
			if(this.getAttribute('value') === items) {
				this.setAttribute('selected', 'selected');
				$(".items-select label").text(this.innerHTML);
			}
		});
	}
})();
var showUpdateButton = (function() {
	var inputs = $(".item-quantity-input");

	inputs.change(function() {
		$(this).parents('.cart-item').find('.update').css('display', 'inline-block');
	});
})();
var blogCategories = (function() {
	var select = $(".blog-category-select");

	select.change(function() {
		window.location.href = window.location.origin + $(this).val();
	});
})();

var blogSearch = (function() {
	var form = $(".blog-options .search-form");

	form.submit(function(e) {
		e.preventDefault();
		window.location.href = window.location.origin + "/search?" + $(this).serialize();
	});
})();
var bannerVideo = (function() {
	var leftImage = $("#home-hero .banner-image.left"),
		rightImage = $("#home-hero .banner-image.right"),
		bannerVideo = document.querySelector('#banner-video video');

	if(bannerVideo) {
		bannerVideo.addEventListener('canplaythrough', function() {
			bannerVideo.play();
			unveilBanner();
		}, false);

		bannerVideo.addEventListener('ended', function() {
			bannerVideo.pause();
			bannerVideo.currenTime = 0;
			bannerVideo.play();
		}, false);

		function unveilBanner() {
			leftImage.addClass('active');
			rightImage.addClass('active');
			$("#banner-video").addClass('active');
		}

		if($(window).width() > 1024) {
			var mp4Source = $("#banner-video .mp4"),
				oggSource = $("#banner-video .ogg"),
				webmSource = $("#banner-video .webm");
			if(mp4Source.length) {
				mp4Source.attr('src', mp4Source.attr('data-source'));
			}
			if(oggSource.length) {
				oggSource.attr('src', oggSource.attr('data-source'));
			}
			if(webmSource.length) {
				webmSource.attr('src', webmSource.attr('data-source'));
			}
			bannerVideo.load();
		}
	}
})();

$(document).ready(function() {
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
});
